import React, { Component } from "react";
import BreadcrumbCustomer from "../breadcrumb";
import { Table,Card,Button,message } from "antd";
import { addKey} from "../../utils/utils";
import { GetRoleList } from "../../model/role/requests";
import {dbFields} from '../../model/role/column';
import { route } from '../../routes/routes';
import storage from '../../utils/storage';
import { configs } from '../../config/config';


export default class Role extends React.Component {

    constructor(props){
        super(props)
        this.state= {
            data:[],
            isLoaded:false,
        };
        this.columns = [
            {
                title: dbFields.id.title,
                dataIndex: dbFields.id.key,
                key: dbFields.id.key,
            },
            {
              title: dbFields.name.title,
              dataIndex: dbFields.name.key,
              key: dbFields.name.key,
            },
            {
                title: 'Action',
                dataIndex: '1',
                key: 'action',
                render:(text,record)=>
                    <>
                        <Button
                            shape="round"
                            style={{background: "#851dd6",color:"white" }}
                            type='default' onClick={this.btnFn.bind(this,record)} >
                            Edit
                        </Button>
                        <Button
                            shape="round"
                            style={{background: "#851dd6",color:"white" }}
                            type='default' onClick={this.handleBindPerm.bind(this,record)} >
                            Bind Perm
                        </Button>
                    </>
             
            }
        ]
    }
    componentWillUnmount(){
        if (!storage.check(configs.cache.tokenKey)) {
            this.props.history.push("/")
        }
    }

    componentDidMount(){
        let roleList = []
        GetRoleList().then(res=>{
            if(res.data.code == 200){
                roleList = addKey(res.data.data)
                this.setState({
                    data:roleList,
                    isLoaded:true,
                })
            }else{
                message.warn(res.data.msg)
            }
        }).catch(err=>{
            message.error(err)
        })

    }

    handlerCreate = (e) => {
        console.log(route.role.create)
        this.props.history.push(route.role.create);
    }

    handleBindPerm = (record) => {
        console.log(record)
        this.props.history.push(route.role.perm+record.id);
    }

    btnFn = record => {
        this.props.history.push(route.role.edit + record.id);
    };



    render(){
        return(
            <>
            <BreadcrumbCustomer  first='Role' second=''/>
            <Card>
                <Button 
                 style={{background: "#851dd6",color:"white" }}
                onClick={this.handlerCreate}>Create</Button>
            </Card>
            <Table 
                 dataSource={ this.state.isLoaded ? this.state.data : [] }
                 columns={this.columns} 
            
            />
            </>
        )
    }

}
